import { Box, Button, Checkbox, OutlinedInput, styled } from '@mui/material';

export const StyledContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  borderRadius: '8px',
  width: '384px',
  padding: '32px',
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  backgroundColor: theme.palette.common.white,
}));

export const login = {
  OutlinedInput: styled(OutlinedInput)(({ theme }) => ({
    color: theme.palette.grey[500],
    backgroundColor: theme.palette.grey[200],
    // borderColor: theme.palette.grey[500],
    // '&.Mui-focused': {
    //   borderColor: theme.palette.grey[500],
    // },
  })),
  SubmitButton: styled(Button)(({ theme }) => ({
    padding: '11px 22px',
    backgroundColor: theme.palette.info.main,
  })),
  Checkbox: styled(Checkbox)(({ theme }) => ({
    color: theme.palette.info.main,
    '&.Mui-checked': {
      color: theme.palette.info.main,
    },
  })),
};
